import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import LoginApi from "@/services/login";
import Empresas from "./views/Empresas.vue";
import Errores from "./views/Errores.vue";
import Enviados from "./views/Enviados.vue";
// import Settings from "./views/Settings.vue";
import Dashboard from "./views/Dashboard.vue";
// import Permisos from "./views/Permisos.vue";
// import SinPermiso from "./views/SinPermiso.vue";
// import { Loading } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        isPublic: true,
        isLog: true
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        isPublic: false
      }
    },
    // {
    //   path: "/settings",
    //   name: "settings",
    //   component: Settings,
    //   meta: {
    //     isPublic: false
    //   }
    // },
    {
      path: "/errores",
      name: "errores",
      component: Errores,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/enviados",
      name: "enviados",
      component: Enviados,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/empresas",
      name: "empresas",
      component: Empresas,
      meta: {
        isPublic: false
      }
    }
    // {
    //   path: "/sinpermiso",
    //   name: "sinpermiso",
    //   component: SinPermiso,
    //   meta: {
    //     isPublic: false
    //   }
    // },
    // {
    //   path: "/permisos",
    //   name: "permisos",
    //   component: Permisos,
    //   meta: {
    //     isPublic: false
    //   }
    // },
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.isPublic);
  if (requiresAuth === false) {
    LoginApi.refreshtoken()
      .then(res => {
        store.dispatch("setuser", res.data.usuario);
        // if(to.path == "/permisos"){
        //   let bols = false;
        //   let bols2 = false;
        //   let loadingInstance = Loading.service({ fullscreen: true });
        //   if (store.state.usuario.permisos) {
        //     for (let i = 0; i < store.state.usuario.permisos.length; i++) {
        //       if (store.state.usuario.permisos[i].ruta === "Asignación de Permisos") {
        //         bols = true;
        //         for (
        //           let j = 0;
        //           j < store.state.usuario.permisos[i].accion.length;
        //           j++
        //         ) {
        //           if (store.state.usuario.permisos[i].accion[j] === "Ver") {
        //             bols2 = true;
        //             loadingInstance.close();
        //             next()
        //           }
        //         }
        //       }
        //     }
        //   }
        //   if (bols === false || bols2 === false) {
        //     loadingInstance.close();
        //     // window.location.href = "/sinpermiso";
        //     next("/sinpermiso")
        //   }
        // }
        next();
      })
      .catch(error => {
        console.log(error);
        next("/");
      });
  } else {
    if (to.path == "/") {
      LoginApi.refreshtoken()
        .then(res => {
          store.dispatch("setuser", res.data.usuario);
          next("/home");
        })
        .catch(error => {
          //next("/login")
        });
    }
    next();
  }
});

export default router;
